import React from "react"
import { Modal, ModalHeader, ModalFooter, Button, ModalBody } from "reactstrap"
import { ModalContainerProps } from "./_ModalContainer"

export type ConfirmModalProps = {
    title: string
    content: string | JSX.Element
    onConfirm: () => void
    btnColor?: "danger" | "success"
    confirmText?: string

    /**
     * Optional handler to intercept a cancel click.
     */
    onCancel?: () => void

    /**
     * Optional handler to intercept the modal closing, regardless of
     * selected option.
     */
    onClose?: () => void
}

export const ConfirmModal: React.FC<ConfirmModalProps & ModalContainerProps> = (props) => {

    const handleClose = () => {
        props.onClose && props.onClose()
        props.closeSelf()
    }

    return (
        <Modal
            isOpen
            fade={false}
            toggle={() => {
                props.onCancel && props.onCancel()
                handleClose()
            }}
            backdrop={"static"}
        >

            <ModalHeader>
                {props.title}
            </ModalHeader>

            <ModalBody className="p-3 m-0 bg-light">
                {(typeof props.content === "string") && (
                    <div dangerouslySetInnerHTML={{ __html: props.content }} />
                )}
                {(typeof props.content !== "string" && (
                    props.content
                ))}
            </ModalBody>

            <ModalFooter className="d-flex justify-content-end space-mx-2" >
                <Button
                    size="sm"
                    onClick={() => {
                        props.onConfirm()
                        handleClose()
                    }}
                    color={props.btnColor}
                >
                    {props.confirmText ?? "Confirm"}
                </Button>

                <Button
                    outline
                    size="sm"
                    onClick={() => {
                        props.onCancel && props.onCancel()
                        handleClose()
                    }}
                    title={"Cancel (esc)"}
                >
                    {"Cancel"}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
